import useCatalogueData from "hook/useCatalogueData";
import "swiper/css";
import "swiper/css/navigation";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
import { Link } from "react-router-dom";
import { assetUrl } from "../../utils/api";
import SectionHeader from "../commonComponent/SectionHeader";

const SafiyaCatelouge = () => {
  const { catalogues, loadingCatalogue } = useCatalogueData();
  const { language } = useSettings();
  const { theme } = useSettings();
  const isDark = theme === "dark";

  const SlideSkeleton = () => (
    <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 lg:gap-4 gap-2">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="flex flex-col items-center mb-4 animate-pulse"
        >
          {/* Image */}
          <div
            className={`w-[60px] h-[60px] md:w-[110px] md:h-[110px] rounded-full overflow-hidden
          ${isDark ? "bg-slate-700" : "bg-gray-300"}`}
          />

          {/* Title */}
          <div
            className={`mt-3 h-4 w-16 rounded
          ${isDark ? "bg-slate-700" : "bg-gray-300"}`}
          />
        </div>
      ))}
    </div>
  );

  return (
    <div className="relative md:max-w-7xl mx-auto  sm:px-4 2xl:px-0 lg:px-8  md:pb-4 pb-0 ">
      <div className="pt-2 px-4 rounded">
        {catalogues && <SectionHeader title={t("category", language)} />}
        {loadingCatalogue ? (
          <SlideSkeleton />
        ) : catalogues.length === 0 ? (
          <div className="text-center py-10 my-5">
            <p className="font-semibold">No items available</p>
          </div>
        ) : (
          <div className="pt-2">
            <div className="grid grid-cols-4 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 lg:gap-4 md:gap-2 gap-1">
              {catalogues.map((item, index) => (
                <div
                  key={`${item.id}-${index}`}
                  className="rounded-[10px] overflow-hidden"
                >
                  <Link to={`/category/${item.catalogue_id}`}>
                    <div className="flex flex-col items-center mb-4">
                      <div className="w-[60px] h-[60px] md:w-[110px] md:h-[110px] rounded-full overflow-hidden border ">
                        <img
                          src={assetUrl(item.image_path)}
                          // src={`https://backend.nabilfashion.com/${item.image_path}`}
                          alt={item.title}
                          loading={index < 4 ? "eager" : "lazy"}
                          decoding="async"
                          className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                          draggable={false}
                        />
                      </div>
                      <p className="sm:text-sm text-[11px] font-medium text-center pt-2">
                        {item.title}
                      </p>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SafiyaCatelouge;
